<span class="text-boxed amber-50-bg grey-500-fg m-0">
  {{'LABEL' | translate}}
</span>
